<template>
    <ul :class="$style.bar">
        <li :style="{ backgroundColor: color }"></li>
        <li :style="{ backgroundColor: color }" :class="{ [$style.nocolor]: tier < 2 }"></li>
        <li :style="{ backgroundColor: color }" :class="{ [$style.nocolor]: tier < 3 }"></li>
    </ul>
</template>

<script>
export default {
    props: {
        color: String,
        tier: Number
    }
};
</script>

<style module>
.bar {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    height: 1em;
}

.bar li {
    width: 1em;
    border: 1px solid rgb(0, 0, 0, 0.5);
}

.bar li + li {
    border-left: none;
}

.nocolor {
    background-color: transparent !important;
}
</style>
